import { ArrowRight } from "lucide-react";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { openSupportChatWithMessage } from "@/core/pylon";
import type { MarketingProduct } from "@/product-marketing/types";
import { PRODUCT_MARKETING } from "./content";

export const ProductContact = ({ product }: { product: MarketingProduct }) => {
  const content = PRODUCT_MARKETING[product];
  const contactUs = () => {
    try {
      if (
        !openSupportChatWithMessage(
          `Hi! I am interested in ${content.name}. Can you help enable it for our account?`,
        )
      ) {
        console.error(`Could not open support chat for ${content.name}.`);
      }
    } catch (error) {
      console.error(`Could not open support chat for ${content.name}.`, error);
    }
  };
  return (
    <Stack gap="sm" className="mt-7">
      <Button
        size="lg"
        onClick={contactUs}
        rightIcon={<ArrowRight aria-hidden />}
        className="h-14 rounded-xl bg-orange-60 px-7 text-lg text-white shadow-sm hover:bg-orange-70 focus-visible:ring-2 focus-visible:ring-orange-60 focus-visible:ring-offset-4 active:bg-orange-80"
      >
        Contact us
      </Button>
      <Typography
        variant="bodyW2"
        textColor="secondary"
        className="max-w-xs leading-5"
      >
        Talk with our team about setup for your business.
      </Typography>
    </Stack>
  );
};
